// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"6e57767b","55":"139833a7","61":"71b245a8","68":"20246cba","194":"845c19e4","210":"c11c88f7","300":"52518149","378":"155915cd","453":"41435cd6","570":"ed3334fa","701":"b088a558","727":"cb2c7848","739":"08eeaab8","849":"70a1034f","922":"74e88ca2","994":"76b3022a"}[chunkId] + ".chunk.js";
};